import { render } from "./deposit.vue?vue&type=template&id=66014e6b&scoped=true"
import script from "./deposit.vue?vue&type=script&lang=js"
export * from "./deposit.vue?vue&type=script&lang=js"

import "./deposit.vue?vue&type=style&index=0&id=66014e6b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66014e6b"]])

export default __exports__